import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IBookingImport, IPageInfo } from '@api'
import { BookingImportFragment, PageInfoFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      bookingImports: {
        pageInfo: IPageInfo
        edges: { node: IBookingImport }[]
      }
    }
  }
}

const mutateHandler = handleFetchResult<
  IPayload,
  { pageInfo: IPageInfo; imports: IBookingImport[] }
>({
  handler: ({
    viewer: {
      company: {
        bookingImports: { edges, pageInfo },
      },
    },
  }) => ({ pageInfo, imports: edges.map(({ node }) => node) }),
  name: 'Booking Import',
})

export default function list(after?: string): Promise<{
  pageInfo: IPageInfo
  imports: IBookingImport[]
}> {
  return client.gql.query({ query, variables: { after } }).then(mutateHandler)
}

const query = gql`
  query importsQuery($after: String) {
    viewer {
      company {
        bookingImports(after: $after, first: 20) {
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...BookingImportFragment
            }
          }
        }
      }
    }
  }
  ${BookingImportFragment}
  ${PageInfoFragment}
`
